import React from 'react';
import styled from 'styled-components';
import Anchor from '../Anchor';
import Column from '../Column';
import Row from '../Row';
import Theme from '../../theme';
import IconShopLoggedIn from '../../assets/svgs/header/shop-logged-in.svg';
import IconShoppingCartDesktop from '../../assets/svgs/header/shop.svg';
import IconShoppingCartMobile from '../../assets/svgs/header/mobile-shop.svg';
var SCIconShopLoggedIn = styled(IconShopLoggedIn).withConfig({
  displayName: "ShoppingCart__SCIconShopLoggedIn",
  componentId: "sc-1ddwo4r-0"
})(["vertical-align:middle;& path{fill:", ";}"], function (props) {
  return props.theme === 'dark' ? Theme.colours.white : Theme.colours.black;
});
var SCIconShoppingCartMobile = styled(IconShoppingCartMobile).withConfig({
  displayName: "ShoppingCart__SCIconShoppingCartMobile",
  componentId: "sc-1ddwo4r-1"
})(["vertical-align:middle;& path{fill:", ";}"], function (props) {
  return props.theme === 'dark' ? Theme.colours.white : Theme.colours.black;
});
var SCIconShoppingCartDesktop = styled(IconShoppingCartDesktop).withConfig({
  displayName: "ShoppingCart__SCIconShoppingCartDesktop",
  componentId: "sc-1ddwo4r-2"
})(["vertical-align:middle;& path{fill:", ";}"], function (props) {
  return props.theme === 'dark' ? Theme.colours.white : Theme.colours.black;
});
var ShoppingCart = function ShoppingCart(_ref) {
  var isLoggedIn = _ref.isLoggedIn,
    url = _ref.url,
    theme = _ref.theme;
  return /*#__PURE__*/React.createElement(Anchor, {
    href: url,
    ariaLabel: "Shopping Cart"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Column, {
    sm: 12,
    lg: false
  }, /*#__PURE__*/React.createElement(SCIconShoppingCartMobile, {
    width: 24,
    height: 24,
    theme: theme
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Column, {
    sm: false,
    lg: 12
  }, isLoggedIn ? /*#__PURE__*/React.createElement(SCIconShopLoggedIn, {
    width: 40,
    height: 40,
    theme: theme,
    "data-testid": "SCIconShopLoggedIn"
  }) : /*#__PURE__*/React.createElement(SCIconShoppingCartDesktop, {
    width: 128,
    height: 40,
    theme: theme
  }))));
};
export default ShoppingCart;